import { Link } from 'react-router-dom';

export default function Header() {
  return (
    <header className="bg-white shadow-sm border-b border-gray-200 no-print">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-2">
            <img src="/favicon-64x64.png" alt="Logo" className="w-8 h-8" />
            <h1 className="text-xl font-bold text-indigo-600">Sticker Maker Admin</h1>
          </Link>

          <nav className="flex items-center space-x-6">
            <Link to="/" className="text-gray-700 hover:text-indigo-600 transition-colors">
              Dashboard
            </Link>
            <Link to="/new" className="text-gray-700 hover:text-indigo-600 transition-colors">
              New Project
            </Link>
            <Link to="/projects" className="text-gray-700 hover:text-indigo-600 transition-colors">
              Projects
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
}
